<div class="dialog-card-view info-dialog">
    <mat-dialog-content>
        <div class="dc-main-icon">
            <div *ngIf="content?.image" class="icon-box">
                <img [src]="content.image" alt="icon" />
            </div>
            <div *ngIf="content?.lottie" class="lottie-icon-box">
                <ng-lottie class="lottie-img" [options]="lottie[content.lottie]"></ng-lottie>
            </div>
        </div>

        <p *ngIf="content?.title" class="dc-title-xl dc-text-center">
            {{ content.title }}
        </p>

        <p
            *ngIf="
                (content?.html == undefined || content?.html == false) &&
                content?.description != undefined &&
                content?.description !== ''
            "
            [ngClass]="content?.title ? 'dc-text-lg' : 'dc-title-lg'"
            class="dc-text-center"
        >
            {{ content.description }}
        </p>

        <p
            [ngClass]="content?.title ? 'dc-text-lg' : 'dc-title-lg'"
            class="dc-text-center"
            [innerHtml]="contentDescription"
            *ngIf="content?.html"
        ></p>
    </mat-dialog-content>

    <mat-dialog-actions>
        <div class="dialog-action-wrapper direction-column" [ngClass]="content?.buttonDirection">
            <button type="button" class="btn primary-btn half-btn" (click)="onConfirmClick()">
                {{ content?.confirmButtonName || "Confirm" }}
            </button>
            <button type="button" class="btn secondary-btn half-btn" (click)="onCancelClick()">
                {{ content?.cancelButtonName || "Cancel" }}
            </button>
        </div>
    </mat-dialog-actions>
</div>
